import TagOrderType from "../../enums/tag-order-type";
import {translate} from "../../app/localisation";

const errorTemplate = (message) => `<div class="invalid-feedback d-block">${message}</div>`;
const getError = (field, errors) => errors?.[field] ? errorTemplate(errors[field].join(', ')) : '';

const getCategoryOptions = (selectedValue) => {
    return Object.entries(window.appCategories).map(([value, label]) => {
        const selected = selectedValue == value ? 'selected' : '';
        return `<option value="${value}" ${selected}>${label}</option>`;
    }).join('');
};

const tagItemTemplatePrepaid = function (number, id, defaultChecked, values = {}, errors = {}) {
    return `
        <div class="tag-item-container js_tag_item_container">
            <div class="tag-item-header"> 
                <label>${translate('order')['tag']} ${number}</label>
                <button type="button" class="btn btn-sm btn-outline-danger js_remove_tag_item">
                    &times;
                </button>
            </div>
            
            <div class="tag-type-selector">
                <div class="form-group text-start">
                    <label>
                        <input name="items[${id}][type]"
                               type="radio"
                               class="js_type"
                               value="${TagOrderType.T4A}"
                               ${defaultChecked === TagOrderType.T4A ? 'checked' : ''}
                        > ${translate('enums')['tag_order_type']['t4a']}
                    </label>
                </div>
                <div class="form-group text-start">
                    <label>
                        <input name="items[${id}][type]"
                               type="radio"
                               class="js_type"
                               value="${TagOrderType.PREPAID}"
                               ${defaultChecked === TagOrderType.PREPAID ? 'checked' : ''}
                        > ${translate('enums')['tag_order_type']['prepaid']}
                    </label>
                </div>
            </div>
            
            <div class="form-row-inline">
                <div class="form-group form-group-registration">
                    <input name="items[${id}][registration_plate]"
                           type="text"
                           class="form-control form-control-sm js_registration_plate ${errors['registration_plate'] ? 'is-invalid' : ''}"
                           placeholder="${translate('order')['registration_plate']}"
                           value="${values.registration_plate ?? ''}">
                    ${getError('registration_plate', errors)}
                </div>
                <div class="form-group form-group-category">
                    <select name="items[${id}][category]"
                            class="form-control form-control-sm js_category ${errors['category'] ? 'is-invalid' : ''}">
                        ${getCategoryOptions(values.category)}
                    </select>
                    ${getError('category', errors)}
                </div>
            </div>
            
            <div class="form-group mb-2 js_prepaid_amount_wrapper ${defaultChecked !== TagOrderType.PREPAID ? 'd-none' : ''}">
                <input name="items[${id}][prepaid_amount]"
                       type="text"
                       placeholder="${translate('order')['prepaid_amount']}"
                       class="form-control form-control-sm js_prepaid_amount ${errors['prepaid_amount'] ? 'is-invalid' : ''}"
                       value="${values.prepaid_amount ?? ''}">
                ${getError('prepaid_amount', errors)}
            </div>
        </div>
    `;
};

const tagItemTemplateBranded = function (number, id, defaultChecked, values = {}, errors = {}) {
    return `
        <div class="tag-item-container js_tag_item_container">
            <div class="tag-item-header"> 
                <label>${translate('order')['tag']} ${number}</label>
                <button type="button" class="btn btn-sm btn-outline-danger js_remove_tag_item">
                    &times;
                </button>
            </div>
            
            <div class="form-row-inline">
                <div class="form-group form-group-registration">
                    <input name="items[${id}][registration_plate]"
                           type="text"
                           class="form-control form-control-sm js_registration_plate ${errors['registration_plate'] ? 'is-invalid' : ''}"
                           placeholder="${translate('order')['registration_plate']}"
                           value="${values.registration_plate ?? ''}">
                    ${getError('registration_plate', errors)}
                </div>
                <div class="form-group form-group-category">
                    <select name="items[${id}][category]"
                            class="form-control form-control-sm js_category ${errors['category'] ? 'is-invalid' : ''}">
                        ${getCategoryOptions(values.category)}
                    </select>
                    ${getError('category', errors)}
                </div>
            </div>
            
            <div class="form-group mb-2 js_prepaid_amount_wrapper">
                <input name="items[${id}][branded_text]"
                       type="text"
                       placeholder="${translate('order')['tag_branding_title']}"
                       class="form-control form-control-sm js_customized_text ${errors['branded_text'] ? 'is-invalid' : ''}"
                       value="${values.branded_text ?? ''}">
                ${getError('branded_text', errors)}
            </div>
        </div>
    `;
};

const tagItemTemplate = function (number, id, defaultChecked, values = {}, errors = {}) {
    return `
        <div class="tag-item-container js_tag_item_container">
            <div class="tag-item-header"> 
                <label>${translate('order')['tag']} ${number}</label>
                <button type="button" class="btn btn-sm btn-outline-danger js_remove_tag_item">
                    &times;
                </button>
            </div>
            
            <div class="tag-type-selector">
                <div class="form-group text-start">
                    <label>
                        <input name="items[${id}][type]"
                               type="radio"
                               class="js_type"
                               value="${TagOrderType.T4A}"
                               ${defaultChecked === TagOrderType.T4A ? 'checked' : ''}
                        > ${translate('enums')['tag_order_type']['t4a']}
                    </label>
                </div>
            </div>
            
            <div class="form-row-inline">
                <div class="form-group form-group-registration">
                    <input name="items[${id}][registration_plate]"
                           type="text"
                           class="form-control form-control-sm js_registration_plate ${errors['registration_plate'] ? 'is-invalid' : ''}"
                           placeholder="${translate('order')['registration_plate']}"
                           value="${values.registration_plate ?? ''}">
                    ${getError('registration_plate', errors)}
                </div>
                <div class="form-group form-group-category">
                    <select name="items[${id}][category]"
                            class="form-control form-control-sm js_category ${errors['category'] ? 'is-invalid' : ''}">
                        ${getCategoryOptions(values.category)}
                    </select>
                    ${getError('category', errors)}
                </div>
            </div>
        </div>
    `;
};

export { tagItemTemplatePrepaid, tagItemTemplateBranded, tagItemTemplate };
